import { createSelector } from "@ngrx/store";

import * as fromRoot from "../../../router-store";
import * as fromFeature from "../reducers";
import * as fromGrades from "#core/teacher-classes/store/reducers/grades.reducer";
import * as selectorsHelperFn from "#helpers/selectors.helper";
import { PPAssignment as Assignment } from "cli-types";

// get student state
export const getGradesState = createSelector(
    fromFeature.getCoursesModuleState,
    (state: fromFeature.CoursesState) => state.grades
);

// get student entities
export const getGradesEntities = createSelector(
    getGradesState,
    fromGrades.getGradesEntities
);

// get individual student assignment object
export const getSelectedGrades = createSelector(
    getGradesEntities,
    fromRoot.getRouterState,
    (entities, router): Assignment | null => {
        return selectorsHelperFn.getSelectedEntity<Assignment>(
            entities,
            router,
            "studentId"
        );
    }
);

// convert Entities so view can consume
export const getAllGrades = createSelector(
    getGradesEntities,
    entities => {
        return Array.from(entities.values());
    }
);

export const getGradesLoaded = createSelector(
    getGradesState,
    fromGrades.getGradesLoaded
);

export const getGradesLoading = createSelector(
    getGradesState,
    fromGrades.getGradesLoading
);

export const getGradesEntitiesLoaded = createSelector(
    getGradesState,
    fromGrades.getGradesEntitiesLoaded
);

export const getGradesEntitiesLoading = createSelector(
    getGradesState,
    fromGrades.getGradesEntitiesLoading
);

export const getRawGradeResponse = createSelector(
    getGradesState,
    fromGrades.getRawResponse
);

export const getCurrentAssignment = createSelector(
    getGradesState,
    fromGrades.getCurrentAssignment
);

export const getUpdateStudentAssignmentFailure = createSelector(
    getGradesState,
    fromGrades.updateStudentAssignmentFailure
);
